(() => {
  if (window.__bolodooNativeWomensSuitForm) return;
  window.__bolodooNativeWomensSuitForm = true;

  const rows = [
    { "size": "XS", "jacket": ["15.4", "36.2", "23.2", "24"], "jacketCm": ["39.1", "91.9", "58.9", "61"], "pants": ["26.8", "36.6", "39.4"], "pantsCm": ["68.1", "93", "100.1"] },
    { "size": "S", "jacket": ["15.7", "37.8", "23.6", "24.8"], "jacketCm": ["39.9", "96", "60", "63"], "pants": ["28.7", "38.6", "39.8"], "pantsCm": ["72.9", "98", "101.1"] },
    { "size": "M", "jacket": ["16.3", "40.2", "24", "25.6"], "jacketCm": ["41.4", "102.1", "61", "65"], "pants": ["30.7", "40.6", "40.2"], "pantsCm": ["78", "103.1", "102.1"] },
    { "size": "L", "jacket": ["16.9", "42.5", "24.4", "26.4"], "jacketCm": ["42.9", "108", "62", "67.1"], "pants": ["33.1", "43.3", "40.6"], "pantsCm": ["84.1", "110", "103.1"] },
    { "size": "XL", "jacket": ["17.5", "44.9", "25", "26.8"], "jacketCm": ["44.5", "114", "63.5", "68.1"], "pants": ["35.4", "45.7", "41.3"], "pantsCm": ["89.9", "116.1", "104.9"] },
    { "size": "2XL", "jacket": ["18.1", "47.2", "25.6", "27.2"], "jacketCm": ["46", "119.9", "65", "69.1"], "pants": ["38.6", "48.8", "41.7"], "pantsCm": ["98", "124", "105.9"] },
    { "size": "3XL", "jacket": ["18.9", "49.6", "26", "27.6"], "jacketCm": ["48", "126", "66", "70.1"], "pants": ["41.7", "52", "42.1"], "pantsCm": ["105.9", "132.1", "106.9"] },
  ];
  const jacketHeaders = ["Shoulder", "Bust", "Sleeve", "Length"];
  const pantsHeaders = ["Waist", "Hipline", "Length"];
  const productionTime = [5, 7];
  const shippingTime = { standard: [7, 16], expedited: [5, 9] };
  const addDays = (date, days) => { const result = new Date(date.getTime()); result.setUTCDate(result.getUTCDate() + days); return result; };
  const formatDate = (date) => date.toLocaleString("en-US", { month: "short", timeZone: "UTC" }) + ". " + date.getUTCDate();
  const formatRange = (start, min, max) => formatDate(addDays(start, min)) + " - " + formatDate(addDays(start, max));
  const getDeliveryEstimate = () => {
    const now = new Date();
    const start = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    return {
      tailoring: productionTime[0] + "-" + productionTime[1] + " Days",
      standard: formatRange(start, productionTime[0] + shippingTime.standard[0], productionTime[1] + shippingTime.standard[1]),
      expedited: formatRange(start, productionTime[0] + shippingTime.expedited[0], productionTime[1] + shippingTime.expedited[1]),
    };
  };

  document.querySelectorAll("[data-mws-root]:not([data-mws-ready])").forEach((root) => {
    root.setAttribute("data-mws-ready", "");
    const drawer = root.querySelector("[data-mws-drawer]");
    const chartDrawer = root.querySelector("[data-mws-chart-drawer]");
    const scrim = root.querySelector("[data-mws-backdrop]");
    const sizeGrid = root.querySelector("[data-mws-size-grid]");
    const preview = root.querySelector("[data-mws-preview]");
    const chartBodies = {
      jacket: root.querySelector("[data-mws-chart-body-jacket]"),
      pants: root.querySelector("[data-mws-chart-body-pants]"),
    };
    const confirm = root.querySelector("[data-mws-confirm]");
    const propertyInputs = {
      size: root.querySelector('[data-mws-cart-property="size"]'),
      measurements: root.querySelector('[data-mws-cart-property="measurements"]'),
      tailoringTime: root.querySelector('[data-mws-cart-property="tailoring-time"]'),
      standardDelivery: root.querySelector('[data-mws-cart-property="standard-delivery"]'),
      expeditedDelivery: root.querySelector('[data-mws-cart-property="expedited-delivery"]'),
    };
    const portal = document.createElement("div");
    portal.className = "mws__portal";
    document.body.append(portal);
    portal.append(scrim, drawer, chartDrawer);
    let selectedSize = "";
    let unit = "inch";

    const selectedRow = () => rows.find((row) => row.size === selectedSize);
    const getProductForm = () => {
      const scope = root.closest(".product__info-container") || root.closest('[id^="ProductInfo-"]') || document;
      return scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    };
    const measurementsFor = (row) => {
      const jacket = unit === "cm" ? row.jacketCm : row.jacket;
      const pants = unit === "cm" ? row.pantsCm : row.pants;
      const suffix = unit === "cm" ? " cm" : " inch";
      return [
        "Jacket Shoulder: " + jacket[0] + suffix,
        "Jacket Bust: " + jacket[1] + suffix,
        "Jacket Sleeve: " + jacket[2] + suffix,
        "Jacket Length: " + jacket[3] + suffix,
        "Pants Waist: " + pants[0] + suffix,
        "Pants Hipline: " + pants[1] + suffix,
        "Pants Length: " + pants[2] + suffix,
      ].join("; ");
    };
    const syncCartProperties = () => {
      const row = selectedRow();
      const estimate = getDeliveryEstimate();
      propertyInputs.size.value = row ? row.size : "";
      propertyInputs.measurements.value = row ? measurementsFor(row) : "";
      propertyInputs.tailoringTime.value = estimate.tailoring;
      propertyInputs.standardDelivery.value = estimate.standard;
      propertyInputs.expeditedDelivery.value = estimate.expedited;
      const form = getProductForm();
      if (form) Object.values(propertyInputs).forEach((input) => form.append(input));
    };
    const renderDelivery = () => {
      const estimate = getDeliveryEstimate();
      root.querySelector("[data-mws-tailoring]").textContent = estimate.tailoring;
      root.querySelector("[data-mws-standard-date]").textContent = estimate.standard;
      root.querySelector("[data-mws-expedited-date]").textContent = estimate.expedited;
      root.querySelector("[data-mws-standard-time]").textContent = shippingTime.standard[0] + "-" + shippingTime.standard[1] + " Days";
      root.querySelector("[data-mws-expedited-time]").textContent = shippingTime.expedited[0] + "-" + shippingTime.expedited[1] + " Days";
    };
    const renderRows = (items, type) => items.map((row) => {
      const values = type === "jacket"
        ? (unit === "cm" ? row.jacketCm : row.jacket)
        : (unit === "cm" ? row.pantsCm : row.pants);
      const suffix = unit === "cm" ? " cm" : " inch";
      return '<tr class="' + (row.size === selectedSize ? "is-selected" : "") + '"><th scope="row">' + row.size + '</th>' + values.map((value) => '<td>' + value + suffix + '</td>').join("") + '</tr>';
    }).join("");
    const renderTable = (items, type, title) => '<section class="mws__measurement-group"><h4>' + title + '</h4><div class="mws__table-scroll"><table class="mws__table"><thead><tr><th>Size</th>' + (type === "jacket" ? jacketHeaders : pantsHeaders).map((header) => '<th>' + header + '</th>').join("") + '</tr></thead><tbody>' + renderRows(items, type) + '</tbody></table></div></section>';
    const renderPreview = () => {
      if (!selectedSize) {
        preview.innerHTML = '<p class="mws__preview-empty">Select a size to view jacket and pants measurements.</p>';
        return;
      }
      const index = rows.findIndex((row) => row.size === selectedSize);
      const visibleRows = rows.slice(Math.max(0, index - 1), Math.min(rows.length, index + 2));
      preview.innerHTML = '<h3>Size measurements</h3>' + renderTable(visibleRows, "jacket", "Jacket measurements") + renderTable(visibleRows, "pants", "Pants measurements");
    };
    const render = () => {
      renderDelivery();
      sizeGrid.innerHTML = rows.map((row) => '<button type="button" class="mws__size-option" data-mws-size="' + row.size + '" aria-pressed="' + (row.size === selectedSize) + '">' + row.size + '</button>').join("");
      confirm.disabled = !selectedSize;
      renderPreview();
      chartBodies.jacket.innerHTML = renderRows(rows, "jacket");
      chartBodies.pants.innerHTML = renderRows(rows, "pants");
      root.querySelector('[data-mws-selector-label]').textContent = selectedSize || "Select A Size";
    };
    const close = () => {
      drawer.dataset.open = "false";
      chartDrawer.dataset.open = "false";
      drawer.setAttribute("aria-hidden", "true");
      chartDrawer.setAttribute("aria-hidden", "true");
      drawer.hidden = true;
      chartDrawer.hidden = true;
      scrim.hidden = true;
      document.body.classList.remove("mws-open");
    };
    const open = (panel) => {
      drawer.hidden = panel !== drawer;
      chartDrawer.hidden = panel !== chartDrawer;
      drawer.dataset.open = panel === drawer ? "true" : "false";
      chartDrawer.dataset.open = panel === chartDrawer ? "true" : "false";
      drawer.setAttribute("aria-hidden", String(panel !== drawer));
      chartDrawer.setAttribute("aria-hidden", String(panel !== chartDrawer));
      scrim.hidden = false;
      document.body.classList.add("mws-open");
      panel.querySelector("button")?.focus();
    };
    const showRequiredSizeError = () => {
      root.querySelector("[data-mws-cart-error]").hidden = false;
      open(drawer);
    };
    const enforceRequiredSize = (event) => {
      syncCartProperties();
      if (selectedSize) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showRequiredSizeError();
    };

    root.querySelector("[data-mws-open]").addEventListener("click", () => open(drawer));
    document.addEventListener("click", (event) => {
      if (!root.contains(event.target) && !drawer.contains(event.target) && !chartDrawer.contains(event.target) && event.target !== scrim) return;
      const size = event.target.closest("[data-mws-size]");
      if (size) { selectedSize = size.dataset.mwsSize; root.querySelector("[data-mws-cart-error]").hidden = true; syncCartProperties(); render(); }
      if (event.target.closest("[data-mws-close]") || event.target.closest("[data-mws-chart-close]") || event.target === scrim) close();
      if (event.target.closest("[data-mws-confirm]") && selectedSize) { syncCartProperties(); close(); }
      if (event.target.closest("[data-mws-view-chart]")) open(chartDrawer);
      const unitButton = event.target.closest("[data-mws-unit]");
      if (unitButton) { unit = unitButton.dataset.mwsUnit; root.querySelectorAll("[data-mws-unit]").forEach((button) => button.setAttribute("aria-pressed", String(button === unitButton))); syncCartProperties(); render(); }
    });
    document.addEventListener("submit", (event) => {
      const form = getProductForm();
      if (form && event.target === form) enforceRequiredSize(event);
    }, true);
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && (drawer.dataset.open === "true" || chartDrawer.dataset.open === "true")) close();
    });
    render();
    syncCartProperties();
  });
})();
